// extracted by mini-css-extract-plugin
export default {"textCode":"code_textCode__-xHKw","buttonCode":"code_buttonCode__4Vowr","textSummary":"code_textSummary__OK0ul"};